// extracted by mini-css-extract-plugin
module.exports = {"amp-config-title":"fonts-config_amp-config-title__3d6zw","amp-config-description":"fonts-config_amp-config-description__2QoyR"};